import * as utils from "../../Utilities";
import React, { Component } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import HelpText from './helptext';
import * as aserver from '../../APIClient';
import AlertModal from "../comps/alertModal";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 'auto',
  },
}));

// eslint-disable-next-line 
class Help extends Component {  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
    }
  }

 openDialogue = async () => {
  let modelCard = await aserver.get(`api/v2/markingenginecard`);
  this.setState({ 
    openModal: true,
    modelCardHTML: modelCard.data.html
  });
}

  closeModal=()=>{
    this.setState({
      openModal:false,
    })
  }



  render() {
    const classes = this.props.classes;
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);


    // eslint-disable-next-line
    return (
    <>
      <div className={classes.root}>
          <CssBaseline />
          <main className={classes.content}>
              <div className={classes.appBarSpacer} />
              <Container maxWidth="lg" className={classes.container}>
                  <Grid item xs={12} md={12} lg={12}>
                    <Paper className={fixedHeightPaper}>
                      <HelpText 
                        openModelCard={this.openDialogue}
                        enneaName={utils.assessmentCodeToName('ennea')} fullName={utils.assessmentCodeToName('full')} imfName={utils.assessmentCodeToName('EIT')}
                        enneaTeamName={utils.teamCodeToName('ennea')} fullTeamName={utils.teamCodeToName('full')} imfTeamName={utils.teamCodeToName('EIT')}
                        />
                      <AlertModal
                        isOpen={this.state.openModal}
                        showClose={() => this.closeModal()}
                      >
                       <div 
                       className="mem"
                       dangerouslySetInnerHTML={{ __html: this.state.modelCardHTML }} 
                       />
                      </AlertModal>
                    </Paper>
                  </Grid>
              </Container>
          </main>
      </div>
    </>
    )
  }
}

// eslint-disable-next-line
export default () => {
  const classes = useStyles();
  return (
      <Help classes={classes} />
  )
};
 
